import { CallIntelligenceService, GetCallsCountRequest } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2';
import { DemoInterceptorUtils, FeatureMockRouter } from '@frontend/demo-interceptors';
import { serviceName } from '../../service';
import { BaseMockRouterContext } from './types';

export type CallIntelFiltersMockRouterContext = BaseMockRouterContext;

export const CallIntelFiltersMockRouter: FeatureMockRouter<CallIntelFiltersMockRouterContext> = {
  getRequestInterceptors: ({ interceptorIdPrefix }) => [
    {
      id: `${interceptorIdPrefix}-calls-count`,
      interceptor: async (request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.GetCallsCount,
          requestUrl: request.url,
          method: request.method,
        });
        if (isMatching) {
          const requestBody: GetCallsCountRequest = await request.clone().json();
          requestBody.isDemo = true;
          return new Request(request, {
            body: JSON.stringify(requestBody),
          });
        }
        return request;
      },
    },
  ],
  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries([serviceName, 'GetCallsCount']);
  },
};
